import { Dropdown } from "react-bootstrap"
import { t } from "i18next"
import { NavLink, useNavigate } from "react-router-dom"
import Cookies from "js-cookie"
import AuthService from "@services/auth.service"
import { COOKIE_ENUM } from "@webkit/enums/cookie.enum"
import "@styles/components/userDropdown.scss"

const UserDropdown = () => {
    const navigate = useNavigate()

    const handleLogout = async () => {
        try {
            await AuthService.logout()
            Cookies.remove(COOKIE_ENUM.HST_USER_TOKEN)
            Cookies.remove(COOKIE_ENUM.HST_USER_PROFILE_DATA)
            navigate("/login")
        } catch (error) {
            console.error("Errore nella logout:", error)
        }
    }

    return (
        <Dropdown align="end" className="d-flex justify-content-center align-items-center">
            <Dropdown.Toggle
                variant="secondary"
                id="user-dropdown"
                className="rounded-circle d-flex align-items-center justify-content-center p-2"
                bsPrefix="btn"
            >
                <i className="fa-solid fa-user"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu className="mt-2">
                {/* Profile */}
                <Dropdown.Item as="div" active={false} className="p-0">
                    <NavLink
                        to="/profile"
                        className="dropdown-link"
                    >
                        <i className="fa-regular fa-user" /> {t("label.profile")}
                    </NavLink>
                </Dropdown.Item>

                {/* Settings */}
                <Dropdown.Item as="div" active={false} className="p-0">
                    <NavLink
                        to="/settings"
                        className="dropdown-link"
                    >
                        <i className="fa-solid fa-gear" /> {t("label.settings")}
                    </NavLink>
                </Dropdown.Item>

                <Dropdown.Divider />

                {/* Logout */}
                <Dropdown.Item
                    as="div"
                    role="button"
                    onClick={handleLogout}
                    active={false}
                    className="dropdown-link"
                >
                    <i className="fa-solid fa-right-from-bracket"></i> {t("button.exit")}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default UserDropdown
